export default __webpack_public_path__ + "static/media/logo_AM.c08121cd.svg";